import { IEmailCollectionItem } from '@sales-center/common'

export function formatEmailAddresses(emailAddresses: IEmailCollectionItem[]) {
  return emailAddresses.map((x) => {
    return { ...x, emailAddress: x.emailAddress.toLowerCase() }
  })
}
